import React from 'react';
import { calculatePlates } from '../../utils/workoutUtils';

export default function VisualBarbell({ weight, barWeight }) {
    const plates = calculatePlates(parseFloat(weight || 0), barWeight);

    const plateConfig = {
        25: { color: 'bg-red-600', height: 'h-28', width: 'w-8', text: 'text-white text-sm' },
        20: { color: 'bg-blue-600', height: 'h-28', width: 'w-7', text: 'text-white text-xs' },
        15: { color: 'bg-yellow-500', height: 'h-24', width: 'w-7', text: 'text-black text-xs' },
        10: { color: 'bg-green-600', height: 'h-20', width: 'w-6', text: 'text-white text-[10px]' },
        5: { color: 'bg-white', height: 'h-16', width: 'w-5', text: 'text-black text-[10px]' },
        2.5: { color: 'bg-gray-800', height: 'h-12', width: 'w-4', text: 'text-white text-[9px]' },
        1.25: { color: 'bg-gray-400', height: 'h-10', width: 'w-4', text: 'text-black text-[9px]' }
    };

    return (
        <div className="relative flex items-center justify-center w-full h-32 my-2 overflow-hidden">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[200px] h-4 bg-gradient-to-b from-gray-400 to-gray-500 rounded-sm z-0 border border-gray-600"></div>
            <div className="relative z-10 flex items-center justify-center gap-[2px]">
                <div className="w-3 h-14 bg-gradient-to-b from-gray-300 to-gray-600 border border-black rounded-sm shadow-xl"></div>
                {plates.map((p, idx) => {
                    const config = plateConfig[p] || { color: 'bg-zinc-700', height: 'h-12', width: 'w-4', text: 'text-white text-[9px]' };
                    return (
                        <div key={idx} className={`${config.color} ${config.height} ${config.width} rounded shadow-[0_0_10px_rgba(0,0,0,0.5)] border-2 border-black/40 flex items-center justify-center relative`}>
                            <span className={`font-black tracking-tighter whitespace-nowrap ${config.text} -rotate-90`}>{p}</span>
                        </div>
                    );
                })}
                {plates.length > 0 && (
                    <div className="w-2 h-8 bg-zinc-800 border border-black rounded-sm ml-1 shadow-md"></div>
                )}
            </div>
        </div>
    );
}
